declare global {
  interface Window {
    WebChat?: {
      initialize: (options: WebChatOptions) => void;
      destroy?: () => void;
      hide?: () => void;
    };
  }
}

interface WebChatOptions {
  title: string;
  placeholder: string;
  initialMessage: string;
  apiKey: string;
  primaryColor: string;
  desktop: {
    position: string;
    marginBottom: number;
    marginSide: number;
    showPopup: boolean;
  };
  mobile: {
    position: string;
    marginBottom: number;
    marginSide: number;
    showPopup: boolean;
  };
  closeButtonIcon: string;
}

const initializeWebChat = () => {
  const initChatbot = () => {
    if (window.WebChat) {
      window.WebChat.initialize({
        title: 'Feli - Partners',
        placeholder: 'Escribe tu mensaje aquí',
        initialMessage: '¡Hola! ¿En qué puedo ayudarte hoy?',
        apiKey: import.meta.env.VITE_WEBCHAT_API_KEY,
        primaryColor: '#FF6C5F',
        desktop: {
          position: 'bottom-right',
          marginBottom: 20,
          marginSide: 20,
          showPopup: true,
        },
        mobile: {
          position: 'bottom-right',
          marginBottom: 10,
          marginSide: 10,
          showPopup: true,
        },
        closeButtonIcon: 'default',
      });
    }
  };

  // check if its already loaded
  const scriptExists = document.querySelector('script[src*="notchatbot"]');

  if (scriptExists) {
    const chatSelectors = [
      '#webchat-notchatbot',
      '.webchat-notchatbot',
      '[id*="webchat-notchatbot"]',
      '[class*="webchat-notchatbot"]',
      '[id*="notchatbot"]',
      '[class*="notchatbot"]',
    ];

    const chatExists = chatSelectors.some(selector => {
      try {
        return document.querySelector(selector) !== null;
      } catch (e) {
        return false;
      }
    });

    if (!chatExists && window.WebChat) {
      initChatbot();
    }
    return;
  }

  document.addEventListener('WebChatReady', initChatbot, { once: true });

  const script = document.createElement('script');
  script.src =
    'https://unpkg.com/@developer.notchatbot/webchat@latest/dist/webchat-bundle.min.umd.cjs';
  script.async = true;

  script.onload = () => {
    if (window.WebChat) {
      initChatbot();
    }
  };

  document.body.appendChild(script);
};

const destroyWebChat = () => {
  const selectors = [
    '#webchat-notchatbot',
    '.webchat-notchatbot',
    '[id*="webchat-notchatbot"]',
    '[class*="webchat-notchatbot"]',
    '[id*="notchatbot"]',
    '[class*="notchatbot"]',
  ];

  selectors.forEach(selector => {
    try {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.remove();
      });
    } catch (e) {
      // ignore invalid selectors errors
    }
  });
};

export { initializeWebChat, destroyWebChat };
